import React from 'react';

import './styles.css';
import Throwaway from '../Throwaway';

type Props = {
  gameOverCallback: any;
};

const Throwaways = ({
  gameOverCallback,
}: Props) => {

  function changeValue(amount: number) {
    if (amount >= 8) {
      gameOverCallback();
    }
  }

  return (
    <div className={'throwaway-board'}>
      <div className={'title'}>Throwaways</div>
      <Throwaway value={1} callback={changeValue} />
      <Throwaway value={2} callback={changeValue} />
      <Throwaway value={3} callback={changeValue} />
      <Throwaway value={4} callback={changeValue} />
      <Throwaway value={5} callback={changeValue} />
      <Throwaway value={6} callback={changeValue} />
    </div>
  );
};

export default Throwaways;